import React from 'react';
import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';

// Array de autos, puedes agregar más si tienes más imágenes
const autos = [
  { nombre: 'Auto 1', imagen: '/auto1.png', detalles: 'Modelo, año, etc.' },
  { nombre: 'Auto 2', imagen: '/auto2 (1).png', detalles: 'Modelo, año, etc.' },
  { nombre: 'Auto 3', imagen: '/auto2 (2).png', detalles: 'Modelo, año, etc.' },
  { nombre: 'Auto 4', imagen: '/auto2 (3).png', detalles: 'Modelo, año, etc.' },
  { nombre: 'Auto 5', imagen: '/auto2 (4).png', detalles: 'Modelo, año, etc.' },
  { nombre: 'Auto 6', imagen: '/auto2 (5).png', detalles: 'Modelo, año, etc.' },
  { nombre: 'Auto 7', imagen: '/auto2 (6).png', detalles: 'Modelo, año, etc.' },
];

const AutosCarousel: React.FC = () => {
  return (
    <section className="autos-carousel-section">
      <h2 className="autos-carousel-title">Nuestra flota</h2>
      <div className="autos-carousel-container" style={{ display: 'flex', justifyContent: 'center' }}>
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={24}
          slidesPerView={1}
          navigation
          loop={true}
          centeredSlides={true}
          effect="coverflow"
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 120,
            modifier: 2,
            slideShadows: false,
          }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          breakpoints={{
            640: { slidesPerView: 1, centeredSlides: true },
            900: { slidesPerView: 3, centeredSlides: true },
            1024: { slidesPerView: 3, centeredSlides: true },
            1200: { slidesPerView: 3, centeredSlides: true },
          }}
          className="autos-swiper"
        >
          {autos.map((auto, idx) => (
            <SwiperSlide key={idx}>
              <div className="auto-card">
                <img src={auto.imagen} alt={auto.nombre} className="auto-img" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default AutosCarousel;
